"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServicesContext = exports.createServices = void 0;
const react_1 = __importDefault(require("react"));
const axiosServices_1 = require("../common/services/axiosServices");
const proxyModule_1 = require("../services/proxy/proxyModule");
const productServiceImpl_1 = require("../services/product/productServiceImpl");
const gatsbyModule_1 = require("../services/gatsby/gatsbyModule");
const initialize = () => {
    const services = {};
    return services;
};
const createServices = (magentoUrl) => {
    const services = {
        common: { baseHttpService: undefined, productService: undefined },
        proxy: { proxyService: undefined },
        gatsby: { geolocationService: undefined }
    };
    initializeCommonServices(services, magentoUrl);
    (0, proxyModule_1.initializeProxyServices)(services);
    (0, gatsbyModule_1.initializeGatsbyServices)(services);
    return services;
};
exports.createServices = createServices;
const initializeCommonServices = (services, magentoUrl) => {
    if (magentoUrl) {
        magentoUrl = magentoUrl;
    }
    services.common.baseHttpService = new axiosServices_1.AxiosService('');
    services.common.productService = new productServiceImpl_1.ProductServiceImpl();
};
exports.ServicesContext = react_1.default.createContext(initialize());
//# sourceMappingURL=servicesContext.js.map